import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TabsGestaoEquipamento from './Componentes/TabsGestaoEquipamento'



const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function GestaoEquipamento(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    props.limparEquipamentoSelecao();
  };

  return (
    <div>
     
      <Dialog disableBackdropClick hideBackdrop  onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.equipamentoSelecao} maxWidth='md' closeButton={false} fullWidth>
        <DialogTitle id="customized-dialog-title" onClose={handleClose} style ={{paddingTop:'5px', paddingBottom:'5px'}}>
          Gerenciar Cadastro de Equipamento
        </DialogTitle>
        <DialogContent dividers style ={{ paddingTop:'0px',}}>
          {props.equipamentoSelecao && <TabsGestaoEquipamento equipamento={props.equipamentoSelecao} handleClose = {()=>{
            handleClose()
            props.getData()
            }} />}          
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} variant='contained' color="secondary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
